<template>
   <div>
     <router-view/>

     <!-- <section class="p-10 bg-white" data-aos="fade-down" data-aos-duration="1000">
  <h2 class="text-3xl font-bold text-blue-700 mb-4">Nos Formations Linguistiques</h2>
  <p class="text-gray-600 max-w-2xl">
    Découvrez nos cours d’allemand, d’anglais, de français et d’italien, du niveau A1 à C1.
  </p>
</section>

<section class="p-10 bg-gray-50" data-aos="fade-left" data-aos-duration="1000">
  <h2 class="text-3xl font-bold text-blue-700 mb-4">Accompagnement Voyage Gratuit</h2>
  <p class="text-gray-600 max-w-2xl">
    Nous vous guidons étape par étape dans votre procédure de voyage vers l’étranger.
  </p>
</section> -->

   </div>
</template>